/**
 * Hulptekst onder elke Teams-deeplink (issue #240).
 *
 * Wie naast het werkaccount een prive-Microsoft-account in de Teams-app heeft,
 * belandt bij het openen van een deeplink in een inlogloop en komt de
 * vergadering niet in. Dat is niet in code op te lossen, alleen te voorkomen
 * door het vooraf te zeggen. Eén tekst, zodat agenda en intervisie hetzelfde
 * zeggen.
 */
export function teamsHulptekst(account: string): string {
  return `Lukt het niet? Open Teams eerst met ${account}; een privé-account ernaast laat de deelname vastlopen.`;
}
